import { createSelector } from '@reduxjs/toolkit';
import { GROUP_SETTINGS } from 'config/groupSettings';

//📌 Selector for get all default group settings from current profile.
export const selectDefaultGroupSettings = createSelector(
	[(state) => state.DefaultSettings.groupSettingsData],
	(groupSettings) => groupSettings || []
);

// Selector to dynamically get the groupID of the 'General' settings group
export const selectGroupSettingsGeneralID = createSelector(
	[(state) => state.DefaultSettings.groupSettingsData],
	(groupSettings) => groupSettings.find((group) => group.groupID === GROUP_SETTINGS.GENERAL)?.groupID || null
);
